import React, { useState, useEffect, Fragment, useContext } from "react";

import CardFilters from "./CardFilters";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../store/rootStore";
import { ICard } from "../models/card";


interface IProps {
  cardChosen: ICard;
  position: number;
  changeCard: Function;
}

const CardDetail:React.FC<IProps> = observer(({cardChosen, position, changeCard}) => {

  const rootStore = useContext(RootStoreContext);
  const {card2Chosen, mobileCardShown, flipCard} = rootStore.cardsStore;
  const {subjects} = rootStore.subjectStore;

  const [backgroundImage, setBackgroundImage] = useState();
  const [showFilters, setShowFilters] = useState(false);

  const flipCardOver = () => {
    flipCard();
  }

  const compareCards = () => {
    setShowFilters(!showFilters);
  }

  useEffect(() => {
    const subject = subjects.find(x => x.termTaxonomyId === cardChosen.subjectId);
    if(subject && subject.subjectImage.image) {
      setBackgroundImage({backgroundImage: `url(${subject.subjectImage.image.node.mediaItemUrl})`});
    }

  }, [cardChosen]);

  return (
    <div className={`card__detail card__detail_${position} ${mobileCardShown===position ?'shown':'hidden'}`}>
      {
        backgroundImage && <div className='card__detail-image' style={backgroundImage}></div>
      }
      <div className='card__detail-body'>
        <h1>{cardChosen.subjectTitle} {cardChosen.cardDetails.level}</h1>

        {card2Chosen !== null &&
          <button className='flip-cards' onClick={flipCardOver}>Flip card <i className="fa-solid fa-repeat"></i></button>
        }

        <div className='buttons'>
          {position === 1 && card2Chosen === null &&
            <button onClick={compareCards}>Compare cards <i className="fa-solid fa-grid-2-plus"></i></button>
          }
          {position === 2 && 
            <button onClick={compareCards}>Change card <i className="fa-solid fa-grid-2-plus"></i></button>
          }
          
          <button>Apply now</button>
        </div>

        <CardFilters cardChosen={cardChosen} changeCard={changeCard} showFilters={showFilters} setShowFilters={setShowFilters} />
        

        {
          cardChosen.cardDetails.content != null
            ? <Fragment>
                <div className='card__detail-content' dangerouslySetInnerHTML={{__html: cardChosen.cardDetails.content}} />
              </Fragment>
            : null
        }

        {
          cardChosen.cardDetails.waysOfThinkingAndLearning != null
            ? <Fragment>
                <h2>Ways of thinking and learning</h2>
                <div className='card__detail-content' dangerouslySetInnerHTML={{__html: cardChosen.cardDetails.waysOfThinkingAndLearning}} />
              </Fragment>
            : null
        }

        {
          cardChosen.cardDetails.toolsForWorking != null
            ? <Fragment>
                <h2>Tools for working</h2>
                <div className='card__detail-content' dangerouslySetInnerHTML={{__html: cardChosen.cardDetails.toolsForWorking}} />
              </Fragment>
            : null
        }   

        {
          cardChosen.cardDetails.thePupil != null
            ? <Fragment>
                <h2>The pupil</h2>
                <div className='card__detail-content' dangerouslySetInnerHTML={{__html: cardChosen.cardDetails.thePupil}} />
              </Fragment>
            : null
        }  

      </div>
        
    </div>
  )
});

export default CardDetail;
